import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  Button,
  colors,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { API_URL } from "./Constant";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Colors from "./Colors";
import { BorderColor } from "@mui/icons-material";

const Keyboard = ({ setGameName, gameName }) => {
  const [input, setInput] = useState("");
  const [selectedTab, setSelectedTab] = useState("swaraksharam");
  const [direction, setDirection] = useState("across");
  const [textFieldValues, setTextFieldValues] = useState(Array(8).fill(""));
  const [focusedField, setFocusedField] = useState("textarea");
  const [questionError, setQuestionError] = useState("");
  const [answerError, setAnswerError] = useState("");
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    const storedGameName = localStorage.getItem("gameId");
    const storedCategory = localStorage.getItem("category");

    if (storedGameName) {
      setGameName(storedGameName);
      setInput(storedGameName);
      setIsEdit(true);
    }
  }, []);

  // Define the characters for each tab
  const swaraksharam = [
    "അ",
    "ആ",
    "ഇ",
    "ഈ",
    "ഉ",
    "ഊ",
    "ഋ",
    "എ",
    "ഏ",
    "ഐ",
    "ഒ",
    "ഓ",
    "ഔ",
    "അം",
    "അഃ",
  ];
  const vyanjanaksharam = [
    "ക",
    "ഖ",
    "ഗ",
    "ഘ",
    "ങ",
    "ച",
    "ഛ",
    "ജ",
    "ഝ",
    "ഞ",
    "ട",
    "ഠ",
    "ഡ",
    "ഢ",
    "ണ",
    "ത",
    "ഥ",
    "ദ",
    "ധ",
    "ന",
    "പ",
    "ഫ",
    "ബ",
    "ഭ",
    "മ",
    "യ",
    "ര",
    "ല",
    "വ",
    "ശ",
    "ഷ",
    "സ",
    "ഹ",
    "ള",
    "ഴ",
    "റ",
  ];
  const chinnangal = [
    "ാ",
    "ി",
    "ീ",
    "ു",
    "ൂ",
    "ൃ",
    "െ",
    "േ",
    "ൈ",
    "ൊ",
    "ോ",
    "ൗ",
    "ം",
    "ഃ",
    "്",
    "്യ",
    "്ര",
    "്വ",
    "്ല",
  ];
  const kootaksharam = [
    "ക്ക",
    "ഗ്ഗ",
    "ങ്ങ",
    "ച്ച",
    "ജ്ജ",
    "ഞ്ഞ",
    "ട്ട",
    "ഡ്ഡ",
    "ണ്ണ",
    "ത്ത",
    "ദ്ദ",
    "ന്ന",
    "പ്പ",
    "ബ്ബ",
    "മ്മ",
    "യ്യ",
    "ല്ല",
    "വ്വ",
    "ശ്ശ",
    "സ്സ",
    "ളള",
    "റ്റ",
    "ങ്ക",
    "ഗ്ന",
    "ഗ്മ",
    "ഞ്ച",
    "ണ്മ",
    "ണ്ട",
    "ണ്ഡ",
    "ന്മ",
    "ന്ത",
    "ന്ദ",
    "ത്മ",
    "മ്പ",
    "ഹ്ന",
    "ഹ്മ",
    "ക്ഷ",
    "ജ്ഞ",
    "ശ്ച",
    "ത്ഥ",
    "ത്ഭ",
    "ത്സ",
    "സ്ഥ",
    "സ്റ്റ",
    "ന്ധ",
    "ദ്ധ",
    "ക്സ",
    "സ്മ",
    "സ്ക",
    "സ്പ",
    "ച്ഛ",
    "ഞ്ച",
    "ണ്ട",
    "ന്ത",
    "മ്പ",
    "ൻ്റ",
  ];
  const chillaksharam = ["ൽ", "ൾ", "ൻ", "ർ", "ൺ"];
  const sangyakal = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const specialSymbols = ["@", "#", "-", "_", "!", "$", "%", "^", "&", "*", "(", ")", "+", "=", "~", "`", "{", "}", "[", "]", ":", ";", "'", "\"", "<", ">", ",", ".", "?", "/", "|", "\\"];



  // Handle the Enter key
  const handleEnter = () => {
    // setSubmittedWord(input); // Set the entered word as submitted
    setInput(""); // Clear the input field
  };

  const populateFields = (question) => {
    console.log(question);
    const { answer, question_text, direction, attachment } = question;
    const answerArray = answer.split(",");

    const paddedAnswers = Array(8).fill("");
    for (let i = 0; i < answerArray.length; i++) {
      paddedAnswers[i] = answerArray[i];
    }

    setTextFieldValues(paddedAnswers);
    setInput(question_text);
    setDirection(direction);
    setFileName(attachment);
  };

  const renderButtons = (chars) => {
    const rows = [];
    let row = [];
    chars.forEach((char, index) => {
      // Determine if the button is the last one in a row of 7
      const isLastInRow = row.length === 6; // The 7th button has an index of 6 in a row
      const buttonStyleToUse = {
        ...buttonStyle, // Base style
        marginRight: isLastInRow ? "0" : "5px", // No margin-right for the last button in a row
      };

      // Apply different styling if the character is from the chinnangal array
      const finalButtonStyle = chinnangal.includes(char)
        ? { ...chinnangalButtonStyle, marginRight: isLastInRow ? "0" : "5px" }
        : buttonStyleToUse;

      row.push(
        <button
          key={index}
          onClick={() => handleButtonClick(char)}
          style={finalButtonStyle}
        >
          {char}
        </button>,
      );

      if (row.length === 7) {
        rows.push(
          <div style={gridRowStyle} key={`row-${rows.length}`}>
            {row}
          </div>,
        );
        row = [];
      }
    });

    if (row.length > 0) {
      rows.push(
        <div style={gridRowStyle} key={`row-${rows.length}`}>
          {row}
        </div>,
      );
    }

    return rows;
  };

  const handleButtonClick = (char) => {
    if (focusedField === "textarea") {
      setInput((prev) => prev + char);
    } else {
      const index = parseInt(focusedField.split("-")[1], 10);
      const updatedFields = [...textFieldValues];
      updatedFields[index] += char;
      setTextFieldValues(updatedFields);
    }
    setAnswerError("");
    setQuestionError("");
  };

  const handleBackspace = () => {
    if (focusedField === "textarea") {
      setInput((prev) => prev.slice(0, -1));
    } else {
      const index = parseInt(focusedField.split("-")[1], 10);
      const updatedFields = [...textFieldValues];
      updatedFields[index] = updatedFields[index].slice(0, -1);
      setTextFieldValues(updatedFields);
    }
  };

  const handleFocus = (field) => {
    setFocusedField(field);
    console.log(`Focused on: ${field}`);
  };

  useEffect(() => {
    setGameName(input);
    console.log(`Game: ${gameName}`);
  }, [gameName, input]);

  useEffect(() => {
    console.log(`Currently focused on: ${focusedField}`);
  }, [focusedField]);

  const renderTextFields = () =>
    textFieldValues.map((value, index) => (
      <TextField
        autoComplete="one-time-code"
        key={index}
        value={value}
        onFocus={() => handleFocus(`textfield-${index}`)}
        variant="outlined"
        inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
        sx={{
          width: "12.5%",
          marginRight: index !== textFieldValues.length - 1 ? "5px" : "0",
          background: "white",
        }}
      />
    ));

  const handleFileSelection = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleChange = (e) => {
    const regex = /^[\u0D00-\u0D7F\s]*$/; // Malayalam characters and spaces
    const value = e.target.value;

    console.log(`Typed Value: ${value}`); // Check if this logs correctly

    if (regex.test(value)) {
      setQuestionError("");
      setInput(value);
      setGameName(value); // Updates gameName
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
      }}
    >
      {/* Heading for Direction */}

      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {/* Heading for Question */}
        <Typography variant="h6" gutterBottom>
          Enter a name for your game:
        </Typography>
        {/*       
     <TextField      
  value={input}
  variant="outlined"
  style={{ width: 'calc(100%)', padding: '0px', borderRadius: '4px', marginBottom: '10px' }}
  readOnly={false}
  onChange={(e) => {
    const regex = /^[\u0D00-\u0D7F\s]*$/; 
    const value = e.target.value;
    if (regex.test(value)) {     
      setQuestionError('');
      setInput(value);
      setGameName(value); 
    }
  }}
  onKeyUp={(e) => {
    // Ensure the value updates on key press
    setGameName(e.target.value);
  }}
/> */}

        <TextField
          value={input}
          variant="outlined"
          style={{
            width: "100%",
            padding: "0px",
            borderRadius: "4px",
            marginBottom: "10px",
          }}
          onChange={(e) => {
            const regex = /^[\u0D00-\u0D7F\s]*$/;
            const value = e.target.value;
            if (regex.test(value)) {
              setQuestionError("");
              setInput(value);
              // Update gameName here
            }
          }}
        />

        {questionError && (
          <Typography variant="h6" sx={{ color: "red" }}>
            {questionError}
          </Typography>
        )}
      </Box>

      {/* Tabs for switching between Swar, Vyanjan, Kootaksharam, and Chillaksharam */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          gap: "4px",
        }}
      >
        <button
          onClick={() => setSelectedTab("swaraksharam")}
          style={
            selectedTab === "swaraksharam"
              ? activeTabButtonStyle
              : tabButtonStyle
          }
        >
          സ്വരാക്ഷരം
        </button>
        <button
          onClick={() => setSelectedTab("vyanjanaksharam")}
          style={
            selectedTab === "vyanjanaksharam"
              ? activeTabButtonStyle
              : tabButtonStyle
          }
        >
          വ്യഞ്ജനാക്ഷരം
        </button>
        <button
          onClick={() => setSelectedTab("kootaksharam")}
          style={
            selectedTab === "kootaksharam"
              ? activeTabButtonStyle
              : tabButtonStyle
          }
        >
          കൂട്ടക്ഷരം
        </button>
        <button
          onClick={() => setSelectedTab("chillaksharam")}
          style={
            selectedTab === "chillaksharam"
              ? activeTabButtonStyle
              : tabButtonStyle
          }
        >
          ചില്ലക്ഷരം
        </button>
        <button
          onClick={() => setSelectedTab("sangyakal")}
          style={
            selectedTab === "sangyakal" ? activeTabButtonStyle : tabButtonStyle
          }
        >
          സംഖ്യകൾ
        </button>
        <button
          onClick={() => setSelectedTab("specialSymbols")}
          style={
            selectedTab === "specialSymbols" ? activeTabButtonStyle : tabButtonStyle
          }
        >
         പ്രത്യേക ചിഹ്നം
        </button> 
      </Box>

      {/* Enter and Backspace keys */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "12px",
          width: "100%",
        }}
      >
        <button onClick={handleEnter} style={controlButtonStyle}>
          Enter
        </button>
        <button onClick={handleBackspace} style={controlButtonStyle}>
          Backspace
        </button>
      </div>

      {/* Render the characters based on the selected tab */}
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        {selectedTab === "swaraksharam" && renderButtons(swaraksharam)}
        {selectedTab === "vyanjanaksharam" &&
          renderButtons([...chinnangal, ...vyanjanaksharam])}
        {selectedTab === "kootaksharam" &&
          renderButtons([...chinnangal, ...kootaksharam])}
        {selectedTab === "chillaksharam" && renderButtons(chillaksharam)}
        {selectedTab === "sangyakal" && renderButtons(sangyakal)}
        {selectedTab === "specialSymbols" && renderButtons(specialSymbols)}
      </div>
    </Box>
  );
};

// Style for the character buttons
const buttonStyle = {
  marginTop: "5px",
  padding: "8px",
  fontSize: "12px",
  cursor: "pointer",
  width: "calc(13%)",
  height: "42px",
  border: "1px solid",
  borderRadius: "4px",
  backgroundColor: Colors.keyboardbutton,
  textAlign: "center",
  color: Colors.keyboardbuttonfont,
};

// Style for the control buttons (Enter and Backspace)
const controlButtonStyle = {
  height: "42px",
  borderRadius: "4px",
  border: "1px solid",
  textAlign: "center",
  padding: "8px",
  fontSize: "12px",
  cursor: "pointer",
  backgroundColor: Colors.controlButton,
  fontWeight: "bold",
  color: Colors.controlbuttonfont,
  width: "100%",
};

// Style for the grid rows
const gridRowStyle = {
  display: "flex",
  justifyContent: "flex-start",
  flexWrap: "wrap",
  width: "100%",
};

// Style for the tabs
const tabButtonStyle = {
  padding: "8px",
  width: "fit-content",
  fontSize: "10px",
  color: Colors.tabbuttonfont,
  cursor: "pointer",
  backgroundColor: Colors.tabbutton,
  border: "1px solid #fff",
  borderRadius: "4px",
};

const activeTabButtonStyle = {
  ...tabButtonStyle,
  backgroundColor: Colors.activetabbutton,
  border: "1px solid ",
  BorderColor: "#fff",
  borderRadius: "4px",
  color: Colors.activetabbuttonfont,
  fontSize: "10px",
};

const chinnangalButtonStyle = {
  ...buttonStyle,
  backgroundColor: Colors.chinnangal,
  color: Colors.chinnangalfont, // Set light blue background for Chinnangal buttons
};

export default Keyboard;
